import {
  FACEBOOK as FACEBOOK_CONSTANT,
  INSTAGRAM as INSTAGRAM_CONSTANT,
  TIKTOK as TIKTOK_CONSTANT,
  YOUTUBE as YOUTUBE_CONSTANT,
  LINKEDIN as LINKEDIN_CONSTANT,
} from "../../../utils/constants";

export const AVAILABLE_PLATFORMS = [
  { value: FACEBOOK_CONSTANT },
  { value: INSTAGRAM_CONSTANT },
  { value: TIKTOK_CONSTANT },
  { value: YOUTUBE_CONSTANT },
  { value: LINKEDIN_CONSTANT },
];

export const VIDEO_ONLY_PLATFORMS = [YOUTUBE_CONSTANT];

export const PLATFORMS_WITHOUT_CAROUSEL = [YOUTUBE_CONSTANT, LINKEDIN_CONSTANT];

const disableWhenImage = ({ isImage }) => Boolean(isImage);

export const platformRegistry = {
  [FACEBOOK_CONSTANT]: {
    labelKey: FACEBOOK_CONSTANT,
    isDisabled: () => false,
  },
  [INSTAGRAM_CONSTANT]: {
    labelKey: INSTAGRAM_CONSTANT,
    isDisabled: () => false,
  },
  [TIKTOK_CONSTANT]: {
    labelKey: TIKTOK_CONSTANT,
    isDisabled: () => false,
  },
  [YOUTUBE_CONSTANT]: {
    labelKey: YOUTUBE_CONSTANT,
    isDisabled: disableWhenImage,
  },
  [LINKEDIN_CONSTANT]: {
    labelKey: LINKEDIN_CONSTANT,
    isDisabled: () => false,
  },
};
